import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
import { useIntl } from "@leagueplatform/locales";
import { HeaderNavLink } from "@leagueplatform/solutions-foundation";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";

export const useNavLinksList = () => {
  const { formatMessage } = useIntl();
  const navLinksList: HeaderNavLink[] = [
    {
      to: APP_MANAGED_ROUTES.HOME,
      label: formatMessage({ id: "STR_HOME" }),
      icon: "descriptiveHome",
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.labResults),
      label: formatMessage({ id: "STR_MY_RESULTS" }),
      icon: "descriptivePerson",
    },
    {
      to: APP_MANAGED_ROUTES.SCREENINGS,
      label: formatMessage({ id: "STR_SCREENINGS" }),
      icon: "descriptiveHeart",
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
      label: formatMessage({ id: "STR_JOURNEY" }),
      icon: "capabilityJourney",
    },
    {
      to: APP_MANAGED_ROUTES.RESOURCES,
      label: formatMessage({ id: "STR_RESOURCES" }),
      icon: "capabilityWallet",
    },
  ];
  return {
    navLinks: navLinksList,
  };
};
